import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_assurance_that_chemicals_are_brought_into_facility'

export const dataPointDefinition = {
  retracedId: 'no_assurance_that_chemicals_are_brought_into_facility',
  name: 'No assurance that if chemicals are brought into the facility, contractors submit the relevant Safety Data Sheets ("SDS",',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-con-9x',
      number: 'HS-CON-2-7',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-con-2',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-54,Yes',
      machineShowHide: '[2],hs-54,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-con-9x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30580,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
